<template lang="html">
  <span class="cancelar-nfe">
    <a
      class="button-invoices"
      title="Cancelar"
      @click.prevent="openModal"
    >
      <i class="fa fa-times invoice-icon" />
    </a>

    <Modal
      title="Cancelar Nota Fiscal"
      save-button-text="Cancelar"
      :is-visible="isVisible"
      :close-modal="closeModal"
      :save-button="handleCancel"
    >
      <form @submit.prevent="handleCancel">
        <div class="field">
          <p class="control">
            <strong>Atenção:</strong> <br> Atualmente o prazo máximo para cancelamento de uma NF-e é de 24 horas, após a emissão da mesma.
          </p>
          <label class="label">Justificativa</label>

          <p class="control">
            <textarea
              v-model="mdfe.cancel.xJust"
              class="textarea"
              placeholder="Exemplo: Nota fiscal emitida incorretamente..."
            />
          </p>
        </div>
      </form>
    </Modal>
  </span>
</template>

<script>
import { isEmpty } from 'lodash';
import { http } from 'app/v1/src/plugins/http';
import { getData } from 'app/v1/src/utils/get';

import Modal from 'app/v1/src/components/Modal';

export default {

  components: {
    Modal
  },

  props: {
    id: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false,
      mdfe: {
        cancel: {
          xJust: ''
        }
      },
    };
  },

  methods: {
    openModal() {
      this.isVisible = true;
    },

    closeModal() {
      this.isVisible = false;
    },

    handleCancel() {
      if (this.hasJustification() && this.greaterJustification()) {
        this.submitCancel();
      }
    },

    submitCancel() {
      const { mdfe } = this;
      http.post(`/api/mdfes/${this.id}/cancel`, {
        mdfe
      })
        .then(getData)
        .then(() => {
          this.closeModal();
          this.mdfe.cancel.xJust = '';
        })
        .catch(() => Promise.reject('FAIL_IN_CANCEL_INVOICE'));
    },

    hasJustification() {
      return !isEmpty(this.mdfe.cancel.xJust);
    },

    greaterJustification() {
      return this.mdfe.cancel.xJust.length > 20;
    },
  }
};
</script>
